import { TopicPairParameterJsonKey } from "../models/common";

export const START_DIALOG_TRIGGER_NAME = "MainStartAlgoDialog";

export const ALL_TOPIC_PAIR_NEXT_TRIGGER_KEYS = [
    TopicPairParameterJsonKey.DefaultNextTrigger,
    TopicPairParameterJsonKey.FileTrigger,
    TopicPairParameterJsonKey.GeoTrigger,
    TopicPairParameterJsonKey.TextTrigger,
];

export const NEXT_TRIGGER_TYPE_BACK = "Back";
